import { namespaceConfig } from 'fast-redux'
import { IUserDTO } from '@/shared/services'

export interface ProfileProps extends IUserDTO {
  loading?: boolean,
  permission?: any,
  clientLastUpdate?: Date | number | string
}

const DEFAULT_STATE: ProfileProps = { id: '', status: 1 }

const { action, getState } = namespaceConfig('profile', DEFAULT_STATE)
export const getProfileState = (state: ProfileProps): ProfileProps | undefined => getState(state)
export const getProfileLoadingState = (state: ProfileProps): boolean | undefined => getProfileState(state)?.loading
export const getPermissionState = (state: ProfileProps): ProfileProps | undefined => getState(state)?.permission

export const setProfile = action('setProfile', function (state: ProfileProps, profile?: IUserDTO) {
  const nextState: ProfileProps = {
    ...state,
    ...(profile || {}),
    clientLastUpdate: new Date().getTime()
  }
  return nextState
})

export const setLoadingProfile = action('setLoadingProfile', function (state: ProfileProps, loading: boolean) {
  if (state.loading == loading) {
    return state
  }
  const nextState = {
    ...state,
    loading
  }
  return nextState
})

export const setPermissionState = action('setPermissionState', function (state: ProfileProps, permission?: any) {
  const nextState: ProfileProps = {
    ...state,
    permission: {...(permission || {})},
    clientLastUpdate: new Date().getTime()
  }
  return nextState
})
